import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ErrorHandler } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalInterceptor, MsalModule, MsalService } from "@azure/msal-angular";
import { NgxSpinnerModule } from "ngx-spinner";

import { AppComponent } from './app.component';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { HttpQueueInterceptor } from './interceptors/http-queue-interceptor';
import { SpinnerInterceptor } from './interceptors/spinner.Interceptor';
import { GlobalErrorHandler } from './interceptors/global-error-hadler';

import { ApiRequestQueueService } from './services/common/api-request-queue.service';

import { AppRoutingModule } from './app-routing.module';
import { AppMaterialModule } from './modules/common/material.module';
import { LayoutModule } from './shared/layout/layout.module';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { FooterLayoutComponent } from './shared/layout/footer-layout/footer-layout.component';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
@NgModule({
  declarations: [
    AppComponent,
    AppLayoutComponent,
    FooterLayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AppMaterialModule,
    LayoutModule,
    NgxSpinnerModule,
    MsalModule,
  ],
  providers: [
    Title, ErrorHandler, MsalService, DatePipe, ApiRequestQueueService,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: HttpQueueInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
